import React from "react";

const CustomIframe = ({ caption, data }) => {
  return (
    <figure className="text-center">
      <div
        className="w-full flex flex-col items-center custom-iframe"
        dangerouslySetInnerHTML={{ __html: data.html }}
      ></div>
      {caption && (
        <figcaption dangerouslySetInnerHTML={{ __html: caption }}></figcaption>
      )}
    </figure>
  );
};

export default CustomIframe;
